import React, { useState, useEffect } from "react";
import axios from "axios";
import { MOBILE_WEB_BASE_URL, WEB_BASE_URL } from "../../unified/webbase";
import cookie from "react-cookies";
import { ToastContainer, toast } from "react-toastify";
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
// import PaidIcon from '@mui/icons-material/Paid';
import PaymentsIcon from '@mui/icons-material/Payments';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { BlockLoading } from 'react-loadingg';
import CancelIcon from '@mui/icons-material/Cancel';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
    Filler,
    BarElement,
  } from 'chart.js';
import { faker } from '@faker-js/faker';
import { Bar } from 'react-chartjs-2';

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
    BarElement
);

const Main = () => {
    const token = cookie.load("token");
    const [state, setState] = useState({
        businessName: cookie.load("businessName"),
        userGroup: cookie.load("userGroup"),
        walletBalance: 0,
        vasWalletBalance: 0,
        vouchers: [],
        boughtvouchers: [],
        code: "",
        password: "",
        secretKey: "",
        publicKey: "",
        discount: "",
        userRole: cookie.load("userRole"),
        networks: [],
        dailyReport: [],
        avaliableVouchers: {},
        walletHistory: [],
        mobileStatus: false,
        successfulTransaction: 0,
        unsuccessfulTransaction: 0,
        isLoading: false
    });

    const formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "NGN",
    });

    const getVouchers2 = async () => {
        const today = new Date();
        const todayYear = today.getFullYear();
        const todayMonth = today.getMonth() + 1;
        const todayDate = today.getDate();
        const formattedToday = `${todayYear}-${todayMonth < 10 ? '0' : ''}${todayMonth}-${todayDate < 10 ? '0' : ''}${todayDate}`;
        
        let successfulCount = 0;
        let unsuccessfulCount = 0;
        
        const id = toast.loading("Please wait...");
        try {
            const res = await axios.get(MOBILE_WEB_BASE_URL + "topupmobile-custom-report?startDate=2024-01-01&endDate=" + formattedToday, {
                headers: {
                    authorization: token,
                },
            });
            
            if (res.data.status === "2000") {
                const walletCount = res.data.data;
                walletCount.forEach(item => {
                    if (item.status === "successfull") {
                        successfulCount++;
                    } else if (item.status === "unsuccessfull") {
                        unsuccessfulCount++;
                    }
                });
                
                setState(prev => ({
                    ...prev,
                    successfulTransaction: successfulCount,
                    unsuccessfulTransaction: unsuccessfulCount,
                    walletHistory: res.data.data.reverse().slice(0, 10)
                }));
                toast.dismiss(id);
            } else {
                toast.update(id, {
                    render: res.data.description,
                    type: "error",
                    isLoading: false,
                });
            }
        } catch (err) {
            toast.update(id, {
                render: "" + err,
                type: "error",
                isLoading: false,
            });
        }
    };

    const getWalletBalance = async () => {
        try {
            const res = await axios.get(WEB_BASE_URL + "/onboarding/account-balance", {
                headers: {
                    authorization: token,
                },
            });
            
            cookie.save("walletBalance", res.data.data.unicardBalance, {
                path: "/",
                expires: new Date(Date.now() + 60 * 30 * 1000),
            });

            setState(prev => ({
                ...prev,
                walletBalance: res.data.data.unicardBalance,
                vasWalletBalance: res.data.data.unicardBalance || 0
            }));
        } catch (err) {
            console.log(WEB_BASE_URL + " " + err);
        }
    };

    const getMobileStatus = () => {
        return false;
    };

    useEffect(() => {
        const user = cookie.load("user");
        if (user !== undefined) {
            getWalletBalance();
            getVouchers2();
            setState(prev => ({
                ...prev,
                mobileStatus: getMobileStatus()
            }));
        }
    }, []);

    const options = {
        responsive: true,
        plugins: {
            legend: {
                position: 'top',
            },
            title: {
                display: false,
                text: 'Transaction Statistics',
            },
        },
        scales: {
            x: {
                grid: {
                    display: false,
                },
                scaleLabel: {
                    display: true,
                    labelString: "Transaction Type"
                },
            },
            y: {
                beginAtZero: true,
                grid: {
                    display: false,
                },
                scaleLabel: {
                    display: true,
                    labelString: "Number of transactions"
                },
            }
        }
    };

    const data = {
        labels: ['Transactions'],
        datasets: [
            {
                label: 'Successful',
                data: [state.successfulTransaction],
                backgroundColor: '#76c48b',
                borderColor: '#76c48b',
                borderWidth: 1,
            },
            {
                label: 'Failed',
                data: [state.unsuccessfulTransaction],
                backgroundColor: '#e0365e',
                borderColor: '#e0365e',
                borderWidth: 1,
            }
        ]
    };

    

    return (
        <div className="page-content">
            <ToastContainer
                position="top-center"
                autoClose={false}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick={true}
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
            {state.mobileStatus ? (
                <div>
                    {/* Mobile Status Content */}
                </div>
            ) : (
                <>
                    <div className="row">
                        <div className="col-md-8 card">
                            <div className="overflow-hidden mt-2 radius-10">
                                <div className="card-body" style={{
                                    minHeight: "33vh",
                                    maxHeight: "40vh"
                                }}>
                                    {state.isLoading && <div style={{ width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}><BlockLoading color="#263B95" /></div>}
                                    <Bar options={options} data={data} />
                                </div>
                            </div>
                        </div>

                        <div className="col-sm-4">
                            <div className="row">
                                <div className="col-md-5 card" style={{ margin: "10px" }}>
                                    <div className="overflow-hidden radius-10">
                                        <div className="card-body">
                                            <div className="align-items-stretch justify-content-between overflow-hidden pb-1">
                                                <div className="">
                                                    <AccountBalanceWalletIcon />
                                                    <div className="mb-1 mt-4">VTU Wallet balance</div>
                                                    <h5 className="" style={{
                                                        fontSize: "14px",
                                                        fontWeight: "600",
                                                    }}>
                                                        {formatter.format(state.walletBalance)}
                                                    </h5>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-5 card" style={{ margin: "10px" }}>
                                    <div className="overflow-hidden radius-10">
                                        <div className="card-body">
                                            <div className="align-items-stretch justify-content-between overflow-hidden">
                                                <div className="">
                                                    <PaymentsIcon />
                                                    <div className="mb-1 mt-4">VAS Wallet balance</div>
                                                    <h5 className="" style={{
                                                        fontSize: "14px",
                                                        fontWeight: "600",
                                                    }}>
                                                        {formatter.format(state.vasWalletBalance)}
                                                    </h5>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-5 card" style={{ margin: "10px" }}>
                                    <div className="overflow-hidden radius-10">
                                        <div className="card-body">
                                            <div className="align-items-stretch justify-content-between overflow-hidden">
                                                <div className="">
                                                    <CheckCircleOutlineIcon style={{ color: "green" }} />
                                                    <div className="mb-1 mt-4">Successful transaction</div>
                                                    <h5 className="" style={{
                                                        fontSize: "14px",
                                                        fontWeight: "600",
                                                    }}>{state.successfulTransaction}</h5>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-5 card" style={{ margin: "10px" }}>
                                    <div className="overflow-hidden radius-10">
                                        <div className="card-body">
                                            <div className="align-items-stretch justify-content-between overflow-hidden">
                                                <div className="">
                                                    <CancelIcon style={{ color: "red" }} />
                                                    <div className="mb-1 mt-4">Failed transaction</div>
                                                    <h5 className="" style={{
                                                        fontSize: "14px",
                                                        fontWeight: "600",
                                                    }}>{state.unsuccessfulTransaction}</h5>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-12 col-lg-12 col-xl-12 d-flex">
                            <div className="card radius-10 w-100">
                                <div className="card-body">
                                    <div className="d-flex align-items-center">
                                        <h6 className="mb-0">Recent Transactions</h6>
                                        <div className="fs-5 ms-auto dropdown">
                                            <div className="dropdown-toggle dropdown-toggle-nocaret cursor-pointer" data-bs-toggle="dropdown">
                                                <i className="bi bi-three-dots"></i>
                                            </div>
                                            <ul className="dropdown-menu">
                                                <li><a className="dropdown-item" href="#">Action</a></li>
                                                <li><a className="dropdown-item" href="#">Another action</a></li>
                                                <li><hr className="dropdown-divider" /></li>
                                                <li><a className="dropdown-item" href="#">Something else here</a></li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div className="card-body">
                                        <div className="table-responsive">
                                            <table className="table table-striped table-bordered" style={{ width: "100%" }}>
                                                <thead>
                                                    <tr>
                                                        <th>No</th>
                                                        <th>Product</th>
                                                        <th>Email Address</th>
                                                        <th>Beneficiary Phone</th>
                                                        <th>Customer Ref</th>
                                                        <th>Refund Status</th>
                                                        <th>Status</th>
                                                        <th>Balance after</th>
                                                        <th>Balance before</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {state.walletHistory.map((item, index) => (
                                                        <tr key={index}>
                                                            <td>{index + 1}</td>
                                                            <td>{item.product}</td>
                                                            <td>{item.emailAddress}</td>
                                                            <td>{item.beneficiaryPhone}</td>
                                                            <td>{item.customerRef}</td>
                                                            <td>{item.refundStatus}</td>
                                                            <td>{item.status}</td>
                                                            <td>{formatter.format(item.amountAfter)}</td>
                                                            <td>{formatter.format(item.amountBefore)}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )}
        </div>
    );
};

export default Main;
